const themeSettings = {
	colors: {
		navyBlue: '#191C63',
		white: '#FFF',
		tiltWhiteOpacity0_08: 'rgba(255,255,255,0.08)',
		tiltBlueBorder: '#F5F6FF',
		pink: '#FF2BF1',
		orange: '#F19A04',
		violet: '#915CE6',
		lightBlue: '#696BAC',
		transparent: 'transparent',
	},

	fontFamily: {
		mainFont: "'Barlow', sans-serif",
	},

	fontWeight: {
		thin: '200',
		light: '300',
		regular: '400',
		medium: '500',
		bold: '700',
		extraBold: '800',
	},

	padding: {
		bigPadding: '0 170px',
		mediumPadding: '0 55px',
		smallPadding: '0 30px',
	},
};

export default themeSettings;
